import { takeLatest, call, put } from "redux-saga/effects";
import { UPDATE_CANDIDATE_EXPERIENCE_REQUEST } from "../../actionTypes";

import {
  updateCandidateExperienceSuccess,
  updateCandidateExperienceError,
} from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* updateCandidatExperience(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/exp_fit", action.payload)
    );
    console.log("res", response.data);
    if (response.data.status == true) {
      yield put(updateCandidateExperienceSuccess(response.data));
    } else {
      yield put(updateCandidateExperienceError(response.data));
    }
  } catch (error) {
    yield put(
      updateCandidateExperienceError({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* updateCandidateExperienceSaga() {
  yield takeLatest(
    UPDATE_CANDIDATE_EXPERIENCE_REQUEST,
    updateCandidatExperience
  );
}
export default updateCandidateExperienceSaga;
